import { BaseServices, HttpMethod } from '@services/base'

import { BridgeService } from './bridge'

export interface PropostasResponse {
  errorCode?: string
  proposals: Array<{
    contract: string
    proposal: string
  }>
}

export default (accessToken?: string) => {
  const pathname = process.env.REACT_APP_CONSULTAR_PROPOSTA
  const method = HttpMethod.GET
  const host = process.env.REACT_APP_API_HOST
  const headers: Record<string, string> = {}

  if (BridgeService.isBrowser() && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  return BaseServices.request<PropostasResponse>({
    headers,
    pathname,
    method,
    host,
  })
}
